/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * a Final risk override reason
 * @export
 * @interface InternalApiAddFinalRiskOverrideReason
 */
export interface InternalApiAddFinalRiskOverrideReason {
    /**
     * a Final risk override reason
     * @type {string}
     * @memberof InternalApiAddFinalRiskOverrideReason
     */
    reason: string;
    /**
     * a Final risk override reason description
     * @type {string}
     * @memberof InternalApiAddFinalRiskOverrideReason
     */
    description: string;
}

/**
 * Check if a given object implements the InternalApiAddFinalRiskOverrideReason interface.
 */
export function instanceOfInternalApiAddFinalRiskOverrideReason(value: object): value is InternalApiAddFinalRiskOverrideReason {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function InternalApiAddFinalRiskOverrideReasonFromJSON(json: any): InternalApiAddFinalRiskOverrideReason {
    return InternalApiAddFinalRiskOverrideReasonFromJSONTyped(json, false);
}

export function InternalApiAddFinalRiskOverrideReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAddFinalRiskOverrideReason {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'],
        'description': json['description'],
    };
}

export function InternalApiAddFinalRiskOverrideReasonToJSON(json: any): InternalApiAddFinalRiskOverrideReason {
    return InternalApiAddFinalRiskOverrideReasonToJSONTyped(json, false);
}

export function InternalApiAddFinalRiskOverrideReasonToJSONTyped(value?: InternalApiAddFinalRiskOverrideReason | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason': value['reason'],
        'description': value['description'],
    };
}

